import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Starfish STD treatment type.
 */
export const StarfishStdTreatment = new TreatmentType({
  id: '5',
  name: ConsultationTreatmentTypes.StarfishStd,
});
